//
// Generated class ProductionNoteLine
//

/// <reference path="ProductionNoteLine_ManagedObject.ts" />

class ProductionNoteLine extends ProductionNoteLine_ManagedObject
{

}
